<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" /> 
    <van-loading v-show="load" class="load" size="60px" color="#27BEC4" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed:{
			load(){
				return this.$store.state.load
			},
  		 ...mapGetters([
	      'load',
	    ])
  	}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  height: 100%;
}
html,body{
	width: 100%;
	height: 100%;
	background: #f8f8f8;
}
.load{
	position: absolute !important;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	width: 50px;
	height: 50px;
	text-align: center;
	line-height: 50px;
	z-index: 999 !important;
}
</style>
